import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { BookingSuccessModal } from "./component";
import {
  getConfirmationDetails,
  getConfirmationDetailsCallState,
  getEarnedString,
  getConfirmationEmail,
  getVacationRentalConfirmationDetails,
  getVRConfirmationDetailsCallState,
  getUserPassengers,
  getOfferToApply,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { actions } from "../../actions";
import { getPremierCollectionShopSelectedAvailability } from "../../../shop/reducer/selectors";
import { getVacationRentalShopSelectedListing } from "../../../vacation-rental-shop/reducer";
import {
  getSelectedAccountReferenceId,
  getRewardsAccounts,
} from "../../../rewards/reducer";
import { getIsTravelApp } from "../../../availability/reducer";

const mapStateToProps = (state: IStoreState) => ({
  reservation: getConfirmationDetails(state),
  confirmationDetailsCallState: getConfirmationDetailsCallState(state),
  selectedLodging: getPremierCollectionShopSelectedAvailability(state),
  earnString: getEarnedString(state),
  confirmationEmail: getConfirmationEmail(state),
  vrReservation: getVacationRentalConfirmationDetails(state),
  vrConfirmationDetailsCallState: getVRConfirmationDetailsCallState(state),
  selectedHome: getVacationRentalShopSelectedListing(state),
  userPassengers: getUserPassengers(state),
  selectedAccountReferenceId: getSelectedAccountReferenceId(state),
  rewardsAccounts: getRewardsAccounts(state),
  isTravelApp: getIsTravelApp(state),
  offerToApply: getOfferToApply(state),
});

const mapDispatchToProps = {
  resetBookState: actions.redoSearch,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type BookingSuccessModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedBookingSuccessModal = withRouter(
  connector(BookingSuccessModal)
);
